module.exports = __webpack_public_path__ + "img/maroon5.203b4ca8.jpg";